import { render, staticRenderFns } from "./VideoPlayer.Error.vue?vue&type=template&id=4ce10a6a&scoped=true&"
import script from "./VideoPlayer.Error.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.Error.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.Error.vue?vue&type=style&index=0&id=4ce10a6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce10a6a",
  null
  
)

component.options.__file = "VideoPlayer.Error.vue"
export default component.exports